import { AddressComponent, AddressComponentCtor } from './Address';
import { CustomerComponent, CustomerComponentCtor } from './Customer';
import { NotesComponent, NotesComponentCtor } from './Notes';
import { CustomerDocumentNumberComponent, CustomerDocumentNumberComponentCtor } from './CustomerDocumentNumber';

export function createFor<T>() {

	const address: AddressComponentCtor<T> = AddressComponent;
	const customer: CustomerComponentCtor<T> = CustomerComponent;
	const notes: NotesComponentCtor<T> = NotesComponent;
	const customerDocumentNumber: CustomerDocumentNumberComponentCtor<T> = CustomerDocumentNumberComponent;

	return {
		Address: address,
		Customer: customer,
		Notes: notes,
		CustomerDocumentNumber: customerDocumentNumber
	};
}
